<template>
  <div class="collect-log-list-container">
    <div class="collect-log-list-tip">
      <template v-if="isWebSocket">
        <p v-html="collectStatusText"></p>
      </template>
      <template v-else>
        <p>您的浏览器版本过低，无法显示日志！</p>
      </template>
    </div>
    <div class="collect-log-list-box">
      <div class="collect-log-list-title">详细日志</div>
      <div class="collect-log-list-detail">
        <ul id="listBox">
          <li v-for="(item, index) in logs" :key="index">
            <p>{{ item | apart(0) }} 开始请求</p>
            <p>{{ item | apart(1) }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'

export default {
  name: 'CollectLogList',
  props: ['detail', 'id', 'end'],
  data () {
    return {
      isWebSocket: true, // 是否支持WebSocket
      logs: [],
      collectTotal: '', // 数据统计结果
      stompClient: '',
      path: '/MODULE-COLLECT/webSocket',
      isEnd: true,
      resetTime: ''
    }
  },
  filters: {
    apart: (value, index) => {
      let text = '开始请求'
      return value.split(text)[index]
    }
  },
  computed: {
    collectStatusText () {
      let text = ''
      switch (this.detail.status) {
        case 0:
          text = '任务未开始'
          break
        case 1:
          text = '正在进行'
          break
        case 2:
          text = '任务已暂停'
          break
        case 3:
          text = '完成'
          break
        default:
          text = '任务未开始'
          break
      }
      return text + this.collectTotal
    }
  },
  mounted () {
    let _this = this
    this.initWebSocket()
    this.resetTime = setInterval(() => {
      if (_this.isEnd) {
        clearInterval(_this.resetTime)
        setTimeout(() => {
          _this.resetEnd()
        }, 120000)
      } else {
        _this.isEnd = true
      }
    }, 5000)
  },
  methods: {
    // webSocket 初始化
    initWebSocket () {
      const host = window.location.protocol + '//' + window.location.host
      const protocol = host.indexOf('https') > -1 ? 'https' : 'http'
      const prefix = protocol+'://api.jeecms.com'
      let _this = this
      if (typeof (WebSocket) === 'undefined') {
        this.isWebSocket = false
      } else {
        let userId = window.localStorage.identity
        let socket = new SockJS(prefix + this.path) // 连接SockJS的endpoint名称为"webSocket"
        _this.stompClient = Stomp.over(socket) // 使用STMOP子协议的WebSocket客户端
        _this.stompClient.connect({}, function (frame) { // 连接WebSocket服务端
          console.log('Connected:' + frame)
          // 通过stompClient.subscribe订阅/process 目标(destination)发送的消息
          _this.stompClient.subscribe('/user/' + userId + '/process/' + _this.id, function (response) {
            _this.collectTotal = response.body
          })
          // 通过stompClient.subscribe订阅/log 目标(destination)发送的消息
          _this.stompClient.subscribe('/user/' + userId + '/log/' + _this.id, function (response) {
            _this.isEnd = false
            _this.logs.push(response.body)
            document.getElementById('listBox').scrollTop = document.getElementById('listBox').scrollHeight + '30'
          })
        })
      }
    },
    // 循环判断是否已经结束了
    resetEnd () {
      if (this.isEnd) {
        this.end()
        this.detail.status = 3
      }
    }
  }
}
</script>

<style lang="scss">
.collect-log-list-container{
  height: 100%;
  .collect-log-list-tip{
    font-size:14px;
    font-weight:300;
    color:rgba(51,51,51,1);
    height: 50px;
    line-height: 50px;
    padding: 0 20px;
  }
  .collect-log-list-box{
    background:rgba(249,249,249,1);
    .collect-log-list-title{
      height: 30px;
      line-height: 30px;
      background:rgba(243,243,243,1);
      padding: 0 20px;
      font-size: 14px;
      color: #333;
    }
    .collect-log-list-detail{
      padding: 20px;
      overflow: hidden;
      ul{
        height: 450px;
        overflow-y: auto;
        p{
          font-size:14px;
          font-weight:300;
          color:rgba(51,51,51,1);
          line-height:20px;
        }
      }
    }
  }
}
</style>
